import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const StyledAmountWithDrawal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .tax-deduction-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 4px;
    .tax-deduction-box {
      padding: 16px;
      background-color: ${COLOR.charcoalV2[64]};
      border-radius: 12px;
      border: 0.5px solid ${COLOR.secondary[16]};
      gap: 12px;
      display: flex;
      flex-direction: column;
      .tax-deduction-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tax-deduction-item-label {
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .icon-info {
          color: ${COLOR.indigo[64]};
          font-size: 16px;
        }
      }
    }
  }
`;
